import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'
import { useTranslation } from 'react-i18next'
import starIcon from '../assets/icons/star.svg'
import Testimony1 from '../../assets/images/testimony1.png'
import Testimony2 from '../../assets/images/testimony2.png'
import Testimony3 from '../../assets/images/testimony3.png'
import Testimony4 from '../../assets/images/testimony4.png'
import Testimony5 from '../../assets/images/testimony5.png'
import Testimony6 from '../../assets/images/testimony6.png'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

export function TestimonialCarousel() {
    const { t } = useTranslation()
    return (
        <div className="hidden lg:!flex lg:!visible lg:fixed right-0 top-0 items-center justify-center w-1/2  h-[90%] bg-gradient-to-b from-[#EBF8F8] from-40% to-transparent">
            <Swiper
                modules={[Pagination, Autoplay]}
                spaceBetween={50}
                slidesPerView={1}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                pagination={{ clickable: true }}
                className="testimonial-swiper w-full max-w-[451px] !px-1"
            >
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial1Text') }}
                        ></div>
                    </div>

                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony1} />
                        <span>{t('Registration.testimonial1Name')}</span>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial6Text') }}
                        ></div>
                    </div>

                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony6} />
                        <span>{t('Registration.testimonial6Name')}</span>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial2Text') }}
                        ></div>
                    </div>
                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony2} />
                        <span>{t('Registration.testimonial2Name')}</span>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial3Text') }}
                        ></div>
                    </div>
                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony3} />
                        <span>{t('Registration.testimonial3Name')}</span>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial4Text') }}
                        ></div>
                    </div>
                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony4} />
                        <span>{t('Registration.testimonial4Name')}</span>
                    </div>
                </SwiperSlide>
                <SwiperSlide className="font-medium h-full w-full !flex flex-col self-end gap-6 justify-between bg-white rounded-[14px] p-8 text-sm">
                    <div className="flex flex-col gap-2">
                        <StarIconList />
                        <div
                            className="text-grey90 before:content-['“'] after:content-['”']"
                            dangerouslySetInnerHTML={{ __html: t('Registration.testimonial5Text') }}
                        ></div>
                    </div>
                    <div className="flex items-center gap-4">
                        <ImageWithFallback src={Testimony5} />
                        <span>{t('Registration.testimonial5Name')}</span>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}

function StarIconList() {
    return (
        <div className="flex gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
                <img key={i} className="size-4" src={starIcon} alt="Star icon" />
            ))}
        </div>
    )
}

function ImageWithFallback({ src }: { src: string }) {
    const [error, setError] = useState(false)

    if (error) {
        return <div className="size-10 rounded-full bg-gray-300" />
    }

    return <img src={src} alt="" onError={() => setError(true)} className="size-10 rounded-full object-cover" />
}
